import React from 'react';
import { DateInput, Input, SelectInput } from '@ktag/styleguide/dist/react';
import { useCodeValues } from './useCodeValues';

interface SearchValueInputProps {
  value?: string;
  label: string;
  attributeName?: string;
  layercaption?: string;
  servicename: string;
  isPublic: boolean;
  dataTyp: string;
  onChange: (e: any) => void;
}

const SearchValueInput = ({
  value,
  label,
  attributeName,
  layercaption,
  servicename,
  isPublic,
  dataTyp,
  onChange,
}: SearchValueInputProps) => {
  if (!(attributeName && layercaption)) return null;

  const inputName = 'searchText';

  const codeValuesQuery = useCodeValues(
    attributeName,
    layercaption,
    servicename,
    isPublic,
  );

  if (codeValuesQuery.isLoading) return null;

  const codeValues = codeValuesQuery.data ?? [];

  const formatDateToString = (dateObject: Date) => {
    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Monate sind 0-indiziert
    const year = dateObject.getFullYear();

    return `${year}-${month}-${day}`;
  };

  if (!codeValues.length)
    if (dataTyp === 'Date') {
      return (
        <DateInput
          label={label}
          name={inputName}
          onInputChange={(e: Date) => {
            onChange({ target: { name: inputName, value: formatDateToString(e) } });
          }}
          showYearSelect
        />
      );
    } else {
      return <Input value={value} label={label} name={inputName} onChange={onChange} />;
    }

  const codeValueOption = codeValues
    .map((item) => ({
      label: item.meaning ? item.meaning : item.codeValue,
      value: item.codeValue,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  if (value === '')
    onChange({ target: { name: inputName, value: codeValueOption[0]?.value } });

  return (
    <SelectInput
      value={value}
      label={label}
      name={inputName}
      onChange={onChange}
      options={codeValueOption}
    />
  );
};

export default SearchValueInput;
